import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const ListadoPTApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRegistrosPT = async (params) => {
        try {
            const finalParams = { ...params, es_producto_terminado: true };
            setCargando(true);
            const response = await api.get("materia_prima", finalParams);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearPT = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("materia_prima", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deletePT = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`materia_prima/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getRegistrosPT,
        crearPT,
        deletePT,

        cargando,
    };
};
